/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { HOME_ROOM } from "../../rooms/RoomNameConstants";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loadingState: {},
    localStream: null,
    audioOnly: true,
    remoteStreams: [],
    history: [{
        ID: HOME_ROOM,
        cache: null,
    }],
    activeRooms: [],
    pendingRequests: [],
    myJoiningRequest: false,
    myInvitations: [],
    participants: [],
    isRoomAlive: false,
    configuredStunServer: false,
    isInMaintenance: "checking",
    openedModal: false
}

const roomSlice = createSlice({
    name: "room",
    initialState: initialState,
    reducers: {
        changeRoom: (state, action) => {
            const targetRoomID = { ID: action.payload, cache: null }
            state.history = [targetRoomID, ...state.history]
        },
        goToPreviousRoom: (state) => {
            state.history = state.history.slice(1)
        },
        cleanHistory: (state) => {
            state.history = initialState.history
        },
        setCache: (state, action) => {
            const { key, data, callback } = action.payload
            state.history[1].cache = {}

            state.history[1].cache[key] = {
                ...data,
                callback
            }
        },
        updateRoomData: (state, action) => {
            const { roomCreator, participants, roomId } = action.payload
            state.roomCreator = roomCreator
            state.participants = participants
            state.roomId = roomId
        },
        addNewJoiner: (state, action) => {
            state.participants.push(action.payload)
        },
        setParticipants: (state, action) => {
            state.participants = action.payload
        },
        updateMute: (state, action) => {
            const { socketId, muted } = action.payload
            state.participants.map((participant) => {
                if (participant.socketId === socketId)
                    participant.muted = muted

                return participant
            })
        },
        updatePlayerHands: (state, action) => {
            const { hands, id } = action.payload
            state.participants.map((participant) => {
                if (participant.socketId === id)
                    participant.hands = hands

                return participant
            })
        },
        participantMovement: (state, action) => {
            const { position, rotation, socketId } = action.payload
            state.participants.map((participant) => {
                if (participant.socketId === socketId) {
                    participant.position = position
                    participant.rotation = rotation
                }

                return participant
            })
        },
        setLocalStream: (state, action) => {
            state.localStream = action.payload
        },
        setRemoteStreams: (state, action) => {
            state.remoteStreams = action.payload
        },
        isAudioOnly: (state, action) => {
            state.audioOnly = action.payload
        },
        resetInitialRoomState: (state) => {
            state.participants = []
            state.pendingRequests = []
            delete state.roomId
            delete state.roomCreator
        },
        loadRemoteHistory: (state, action) => {
            state.history = action.payload
        },
        setIsRoomAlive: (state, action) => {
            state.isRoomAlive = action.payload
        },
        setConfiguredStunServer: (state, action) => {
            state.configuredStunServer = action.payload === '' ?
                false : action.payload
        },
        setIsInMaintenance: (state, action) => {
            state.isInMaintenance = action.payload === 'maintenance'
        },
        updateActiveRooms: (state, action) => {
            state.activeRooms = action.payload
        },
        addInvitation: (state, action) => {
            state.myInvitations.push(action.payload)
        },
        removeInvitation: (state, action) => {
            state.myInvitations = state.myInvitations.filter((mi) => mi.socketId !== action.payload.socketId)
        },
        addPendingRequest: (state, action) => {
            state.pendingRequests.push(action.payload)
        },
        removePendingRequest: (state, action) => {
            const { socketId, type } = action.payload
            state.pendingRequests = state.pendingRequests.filter((pr) => pr.socketId !== socketId && pr.type !== type)
        },
        setMyJoiningRequest: (state, action) => {
            state.myJoiningRequest = action.payload
        },
        setOpenedModal: (state, action) => {
            state.openedModal = action.payload
        }
    }
});

export const {
    goToPreviousRoom,
    addNewJoiner,
    setParticipants,
    participantMovement,
    setConfiguredStunServer,
    setIsInMaintenance,
    updatePlayerHands,
    loadRemoteHistory,
    resetInitialRoomState,
    updateRoomData,
    setIsRoomAlive,
    setLocalStream,
    setRemoteStreams,
    updateActiveRooms,
    addPendingRequest,
    removePendingRequest,
    setMyJoiningRequest,
    addInvitation,
    removeInvitation,
    isAudioOnly,
    changeRoom,
    setCache,
    updateMute,
    setOpenedModal,
    cleanHistory
} = roomSlice.actions

export default roomSlice;
